import * as React from 'react';
import { IUseDropArgs, useDrop } from './dnd';

interface IFieldContainerProps extends IUseDropArgs {
}

export const FieldContainer: React.FunctionComponent<IFieldContainerProps> = (props) => {

    const uiPropsRef = React.useRef<any>({})
    React.useEffect(() => {
        uiPropsRef.current = props.uiProps
    }, [props.uiProps])

    let droppable = useDrop({
        designer: props.designer,
        propPath: props.propPath || ['fields'],
        uiProps: props.uiProps,
        onChangeFields: (newFields) => {
            // props.uiProps seems to reset for some reason. so using ref to keep the changes between renders 
            console.log('props.uiProps', newFields);
            if (props.onChangeFields) {
                props.onChangeFields(newFields)
                return
            }

            props?.designer?.setUIProps(Object.assign({}, uiPropsRef.current, { 'fields': newFields }))
        },
        contextData: props.contextData,
        dataKey: props.dataKey,
        onChangeData: props.onChangeData,
        uxpContext: props.uxpContext,
        disabled: props.disabled,
        isMobile: props.isMobile || false,
        droppableContainerId: props.droppableContainerId,
        droppableParentContainerId: props.droppableParentContainerId,
        proxyContainerId: props.proxyContainerId
    });
    return <>{droppable}</>
}